<!-- Loading bar -->
<!-- <fuse-loading-bar></fuse-loading-bar> -->

<!-- Navigation -->
<fuse-vertical-navigation [class]="'dark bg-corpo-darkgreen print:hidden ' + sideBarClasses" [appearance]="navigationAppearance"
    [mode]="isScreenSmall ? 'over' : 'side'" [name]="'mainNavigation'" [navigation]="navigation.default"
    [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <!-- Logo -->

        <div class="flex items-center justify-center" style="height: 50px;" [class.invert]="sideBarClasses.includes('bg-white')">
            <img style="max-width:max(0px, calc((100% - 150px)*1000)); overflow: hidden;" class="w-40" 
                src="/images/logo/logo-long.png" alt="Logo image">
            <img style="max-width:max(0px, calc((90px - 100%)*1000)); overflow: hidden;" class="w-12"
                src="/images/logo/logo.png" alt="Logo image">
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0 max-h-full min-h-0">

    <!-- Header -->
    <div
        [class]="'relative flex flex-0 items-center w-full h-12 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b dark:bg-transparent print:hidden ' + headerClasses">
        <div class="flex items-center pr-2 space-x-2">
            <!-- Navigation toggle button -->
            <!--button
                mat-icon-button
                (click)="toggleNavigation('mainNavigation')">
                <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
            </button-->
            <!-- Navigation appearance toggle button -->
            <!--button
                class="hidden md:inline-flex"
                mat-icon-button
                (click)="toggleNavigationAppearance()">
                <mat-icon [svgIcon]="'heroicons_outline:switch-horizontal'"></mat-icon>
            </button-->
            <div class="w-2"></div>
            <ng-container *ngFor="let item of ariane;">
                <a class="text-background-primary" [href]="item.link">{{item.title}} <ng-container
                        *ngIf="!item.last">></ng-container></a>
            </ng-container>
        </div>
        <!-- Components -->
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
            <button mat-icon-button (click)="toggleCDCSpace()"
                *ngIf="hasCDCSpaceAccess"
                [title]=" currentSpace == 'normal' ? 'Switch to CDC Space' : 'Switch to Corporating Space'">
                <fa-icon [icon]="['fas', 'repeat']" class="text-white icon-size-4"></fa-icon>
            </button>
            <p *ngIf="currentSpace != 'normal'" class="text-white font-semibold">Switch to Corporating Space</p>
            <button class="btn-primary-sm" (click)="onSubscribeClick()" *ngIf="isFreemium" data-test-id="subscribe-btn">
                <fa-icon [icon]="['fas', 'unlock']" class="icon-size-3 mb-1 mr-1"></fa-icon>
                Subscribe to Premium
            </button>
            <button mat-icon-button *ngIf="isAdmin" (click)="goToAdmin($event)">
                <mat-icon class="rounded-full" style="color: white;"
                    svgIcon="mat_outline:home_repair_service"></mat-icon>
            </button>
            <!--fuse-fullscreen class="hidden md:block"></fuse-fullscreen-->
            <notifications *ngIf="isAdmin"></notifications>
            <user class="mt-1"></user>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto min-h-0 h-screen w-full max-h-full overflow-y-auto">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <div
        class="relative flex items-center justify-around w-full h-18 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden text-gray-400">
        <div class="hover:text-gray-700 cursor-pointer">
            <a class="truncate" href="https://support.corporatings.com/release_notes/">
                <p>Version {{version?.buildDate}}</p>
            </a>
        </div>
        <div class="w-1/2 max-w-1/2 flex justify-center items-center h-full font-semibold">
            <div style="max-width: calc(33% - 80px);" class="truncate"
                class="flex space-x-2 hover:text-gray-700 cursor-pointer" (click)="goToHubspot()">
                <fa-icon [icon]="['fas', 'calendar-days']" class="icon-size-4 flex items-center"></fa-icon>
                <p class="truncate">Book a call</p>
            </div>

            <div class="w-10"></div>

            <a style="max-width: calc(33% - 80px);" href="mailto:contact&#64;corporatings.com">
                <div style="max-width: calc(33% - 80px);"
                    class="flex max-w-full space-x-2 hover:text-gray-700 cursor-pointer">
                    <fa-icon [icon]="['fas', 'envelope']" class="icon-size-4 flex items-center"></fa-icon>
                    <p class="truncate">Contact</p>
                </div>
            </a>

            <div class="w-10"></div>

            <a style="max-width: calc(33% - 80px);" href="mailto:support&#64;corporatings.com">
                <div style="max-width: calc(33% - 80px);"
                    class="flex  max-w-full space-x-2 hover:text-gray-700 cursor-pointer">
                    <fa-icon [icon]="['fas', 'envelope']" class="icon-size-4 flex items-center"></fa-icon>
                    <p class="truncate">Support</p>
                </div>
            </a>


        </div>
        <span class="text-secondary">Corporatings &copy; {{currentYear}}</span>

    </div>

</div>